import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  ', ' ', ';\n'], ['\n  display: flex;\n  ', ' ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    margin-left: -', 'px;\n    margin-top: ', 'px;\n  '], ['\n    margin-left: -', 'px;\n    margin-top: ', 'px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    margin-left: -', 'px;\n    margin-right: -', 'px;\n    margin-top: ', 'px;\n    margin-bottom: ', 'px;\n    border-top: 1px solid ', ';\n  '], ['\n    margin-left: -', 'px;\n    margin-right: -', 'px;\n    margin-top: ', 'px;\n    margin-bottom: ', 'px;\n    border-top: 1px solid ', ';\n  ']);

import styled from 'styled-components';
import { gridSize } from '../../shared-variables';
import { getProvided, whenCollapsedAndNotInOverflowDropdown, whenNotInOverflowDropdown } from '../../theme/util';

var NavigationItemGroupHeader = styled.div(_templateObject, whenNotInOverflowDropdown(_templateObject2, gridSize, gridSize * 1.5), whenCollapsedAndNotInOverflowDropdown(_templateObject3, gridSize, gridSize, gridSize, gridSize, function (_ref) {
  var theme = _ref.theme;
  return getProvided(theme).keyline;
}));

NavigationItemGroupHeader.displayName = 'NavigationItemGroupHeader';
export default NavigationItemGroupHeader;